<!-- <img src="../../../../assets/images/img1.jpeg" alt="" width="100%" height="100%">  -->
<!-- <img src="../../../../assets/images/img2.jpeg" alt="" width="100%" height="100%">  -->
<!-- <img src="../../../../assets/images/img3.jpeg" alt="" width="100%" height="100%"> -->
<!-- <img src="../../../../assets/images/chargeback.png" alt="" width="100%" height="100%">  -->


<div class="toolbar" id="kt_toolbar">
    <!--begin::Container-->
    <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            class="page-title d-flex align-items-center me-3 flex-wrap mb-5 mb-lg-0 lh-1">
            <!--begin::Title-->
            <h1 class="d-flex align-items-center text-dark fw-bold my-1 fs-3">Realtime Risk Monitoring</h1>
            <!--end::Title-->
        </div>
        <!--end::Page title-->
    </div>
    <!--end::Container-->
</div>
<div class="col-xl-12">
    <button type="button" class="btn bg-danger-custom" [ngClass]="{'green' : selectedTab==='RN', 'red': selectedTab!='RN'}"  (click)="sendRiskType('RN')"><i class="feather icon-bell"></i>
        Risk Notification </button>
    <button type="button" class="btn bg-danger-custom" [ngClass]="{'green' : selectedTab==='IT', 'red': selectedTab!='IT'}"  (click)="sendRiskType('IT')"><i
            class="feather icon-crosshair"></i> IP Tracking</button>
    <button class="btn bg-danger-custom"  [ngClass]="{'green' : selectedTab==='BS', 'red': selectedTab!='BS'}"  (click)="sendRiskType('BS')"> <i class="feather icon-globe"></i> Browser
        Signature </button>
    <button class="btn bg-danger-custom" [ngClass]="{'green' : selectedTab==='CB', 'red': selectedTab!='CB'}"  (click)="sendRiskType('CB')"> ₹ Chargeback</button>
    <button type="button" class="btn bg-danger-custom" [ngClass]="{'green' : selectedTab==='HRN', 'red': selectedTab!='HRN'}"  (click)="sendRiskType('HRN')"><i class="feather icon-bell"></i>
        High Risk Transaction </button>
    <div class="card">
        <div class="card-body py-0 pl-3 on-boarding-tab ">
            <form [formGroup]="dynamicForm" novalidate>
                <div class="row mt-2">
                    <div class="col-md-4" *ngIf="!isButtonShow">
                        <div *ngFor="let controls of DynamicScreenControls">
                            <div [ngSwitch]="controls.control_type">
                                <div *ngSwitchCase="'text'">
                                    <label class="d-flex align-items-center fs-6 fw-semibold">
                                        <span class="">{{controls.control_title}}</span>
                                    </label>
                                    <input class="form-control form-control-solid" *ngSwitchCase="'text'"
                                        [formControlName]="controls.control_id" [id]="controls.control_id"
                                        [type]="controls.control_type" [placeholder]="controls.control_title"
                                        [name]="controls.control_id" [(ngModel)]="controls.control_default_value"
                                        [pattern]="controls.validation_regex" />
                                </div>
                                <input class="form-control form-control-solid" *ngSwitchCase="'hidden'"
                                    [formControlName]="controls.control_id" [id]="controls.control_id"
                                    [type]="controls.control_type" [name]="controls.control_id"
                                    [(ngModel)]="controls.control_default_value" />
                                <div *ngSwitchCase="'select'">
                                    <label class="d-flex align-items-center fs-6 fw-semibold"><span
                                            class="">{{controls.control_title}}</span></label>
                                    <ng-select style="overflow: visible;" *ngSwitchCase="'select'"
                                        [formControlName]="controls.control_id" [id]="controls.control_id"
                                        [placeholder]="controls.control_title" class="form-select form-select-solid"
                                        (change)="changeEvent($event)">
                                        <ng-option *ngFor="let key_value of controls.list_of_values"
                                            [value]="key_value.value"> {{key_value.key}} </ng-option>
                                    </ng-select>
                                </div>
                                <div *ngSwitchCase="'mselect'">
                                    <label class="d-flex align-items-center fs-6 fw-semibold"><span
                                            class="">{{controls.control_title}}</span></label>
                                    <ng-select style="overflow: visible;" *ngSwitchCase="'text'"
                                        [formControlName]="controls.control_id" [id]="controls.control_id"
                                        [placeholder]="controls.control_title" [multiple]="true"
                                        class="form-select form-select-solid">
                                        <ng-option *ngFor="let key_value of controls.list_of_values"
                                            [value]="key_value.value">
                                            {{key_value.key}}
                                        </ng-option>
                                    </ng-select>
                                </div>
                                <div *ngSwitchCase="'date'">
                                    <label class="d-flex align-items-center fs-6 fw-semibold"><span
                                            class="">{{controls.control_title}}</span></label>
                                    <input class="form-select form-select-solid" *ngSwitchCase="'date'"
                                        [id]="controls.control_id" [type]="controls.control_type" [max]="todayDate"
                                        [formControlName]="controls.control_id" [placeholder]="controls.control_title"
                                        [name]="controls.id" [(ngModel)]="controls.control_default_value" />
                                </div>
                                <div *ngSwitchCase="'time'">
                                    <label class="d-flex align-items-center fs-6 fw-semibold"> <span
                                            class="">{{controls.control_title}}</span></label>
                                    <input class="form-select form-select-solid" *ngSwitchCase="'time'"
                                        [id]="controls.control_id" [type]="controls.control_type"
                                        [formControlName]="controls.control_id" [placeholder]="controls.control_title"
                                        [name]="controls.id" />
                                </div>
                                <div class="mb-3 col-md-4" *ngSwitchCase="'button'">
                                    <button class="form-control btn btn-primary pull-right col-md-4"
                                        *ngSwitchCase="'button'" [type]="controls.control_type"
                                        (click)="onDynamicButtonClick(controls)"> {{controls.control_title}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4" *ngIf="isButtonShow">
                        <div class="panel panel-success  m-1">
                            <div class="panel-heading">
                                <strong>
                                    {{DynamicScreenControls[0]?.title}}
                                </strong>
                            </div>
                            <div class="panel-body">

                            </div>
                        </div>
                    </div>

                    <div class="col-md-8 mt-4 float-right mb-2">
                        <div class="right">
                            <button type="reset" class="btn btn-primary" *ngIf="!isButtonShow">Reset</button>
                            <button class="btn btn-primary" (click)="downloadExcel()">Download</button>
                            <button class="btn btn-primary" (click)="onSubmit()" *ngIf="!isButtonShow">Submit</button>
                        </div>
                    </div>


                </div>
                <div class="row" *ngIf="!isButtonShow">
                    <div class="col-md-4">
                        <div class="panel panel-success  m-1">
                            <div class="panel-heading">
                                <strong>
                                    {{DynamicScreenControls[0]?.title}}
                                </strong>
                            </div>
                            <div class="panel-body">

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="row" style="min-height: 300px">
        <div class="col-lg-12 stretch-card  "  >

            <ag-grid-angular style="width: 100%; height: 350px;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true" [groupSelectsChildren]="true"
                [rowSelection]="'multiple'" [columnDefs]="tableSelectedColumn" [pagination]="true" [rowData]="rowData"
                (gridReady)="onGridReady($event)" (rowClicked)="OnRowClicked($event)"></ag-grid-angular>


            <!-- <ag-grid-angular [enableCellTextSelection]=true [columnDefs]="tableSelectedColumn"
                [defaultColDef]="defaultColDef" [pagination]="true" [rowData]="rowData" [rowModelType]=""
                (gridReady)="onGridReady($event)" [rowSelection]="'multiple'" [animateRows]="true"
                [suppressPaginationPanel]="true" [gridOptions]="gridOptions" [paginationPageSize]=10 class="ag-theme-alpine" style="width: 100%; height: 350px;">
            </ag-grid-angular>  -->

        </div>
        <!-- <div class="col-lg-12 stretch-card  " *ngIf="showgrid">

            <ag-grid-angular style="width: 100%; height: 350px;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true" [groupSelectsChildren]="true"
                [rowSelection]="'multiple'" [columnDefs]="tableSelectedColumn" [pagination]="true" [rowData]="rowData"
                (gridReady)="onGridReady($event)" (rowClicked)="OnRowClicked()"></ag-grid-angular>


           

        </div> -->
    </div>
</div>
<app-modal #modalbloked [modalConfig]="modalConfigBlocked" *ngIf="showgrid">
    <!-- {{aa | json}}   -->
    <!-- {{aa[0]?.action}} -->
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Action</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{aa[0]?.action}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Completed At</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{aa[0]?.completed_at}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Created At</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{aa[0]?.created_at}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Group Id</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{aa[0]?.group_id}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Request Id</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{aa[0]?.request_id}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left font-weight-bold">
            <label class="form-label">Result</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label"></label>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left  ml-1">
            <label class="form-label font-style-italic">first Seen</label>
        </div>
        <div class="col-sm-6 col-md-6">
            <label class="form-label"></label>
        </div>
        <div class="col-md-9 float-left ml-5">
            <div class="row">
                <div class="col-sm-4 col-md-4">
                    <label class="form-label">Human</label>
                </div>
                <div class="col-sm-7 col-md-7">
                    <label class="form-label float-left">{{aa[0].result?.source_output.advanced.first_seen.human}}</label>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-4 col-md-4">
                    <label class="form-label">ISO</label>
                </div>
                <div class="col-sm-7 col-md-7">
                    <label class="form-label  float-left">{{aa[0].result?.source_output.advanced.first_seen.iso}}</label>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-4 col-md-4">
                    <label class="form-label">Sanitized Email</label>
                </div>
                <div class="col-sm-7 col-md-7">
                    <label class="form-label  float-left">{{aa[0].result?.source_output.advanced.sanitized_email}}</label>
                </div>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left  ml-1">
            <label class="form-label font-style-italic">Risk</label>
        </div>
        <div class="col-sm-6 col-md-6">
            <label class="form-label"></label>
        </div>
        <div class="col-md-9 float-left ml-5">
            <div class="row">
                <div class="col-sm-4 col-md-4">
                    <label class="form-label">Is Generic</label>
                </div>
                <div class="col-sm-7 col-md-7">
                    <label class="form-label  float-left">{{aa[0].result?.source_output.risk.is_generic}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 col-md-4">
                    <label class="form-label">Is Honeypot</label>
                </div>
                <div class="col-sm-7 col-md-7">
                    <label class="form-label  float-left">{{aa[0].result?.source_output.risk.is_honeypot}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 col-md-4">
                    <label class="form-label">Is Leaked</label>
                </div>
                <div class="col-sm-7 col-md-7">
                    <label class="form-label  float-left">{{aa[0].result?.source_output.risk.is_leaked}}</label>
                </div>
            </div>
        </div>
    </div>

   
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Status</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{aa[0].result?.source_output.status}}</label>
        </div>
    </div>
</app-modal>